import _ from 'underscore';
import * as putil from '@bingads-webui-universal/primitive-utilities';

let Permissions;
let propsToDelete;

export function initialize({
  globalConfig,
}) {
  Permissions = globalConfig.get('Permissions');

  propsToDelete = _.compact([
    putil.get(Permissions, 'IsAvgPositionDeprecationPhase2Enabled') ?
      {
        key: 'AveragePosition',
        value: {
          alias: { legacy: 'AveragePosition' },
          isDeletedProperty: true,
          format: undefined,
          name: 'Double',
          type: 'number',
          filterable: true,
          nullable: true,
        },
      } : null,
  ]);
}

export function updateEntitySchemaForRemovedPerformanceMetrics(
  originalSchema,
  copy = true,
  expression = null
) {
  const schema = (copy ? putil.cloneDeep : _.identity)(originalSchema);
  const performanceMetrics = putil.get(schema, 'properties.PerformanceMetrics') || putil.get(schema, 'properties.Metrics') || putil.get(schema, 'properties');

  if (performanceMetrics) {
    const performanceMetricsProperties = putil.get(performanceMetrics, 'schema.properties');

    if (performanceMetricsProperties) {
      _.each(propsToDelete, (property) => {
        if (expression) {
          if (_.isArray(performanceMetrics.filterable)) {
            performanceMetrics.filterable.push(property.key);
          }
          performanceMetricsProperties[property.key] = property.value;
        } else {
          delete performanceMetricsProperties[property.key];
        }
      });
    }
  }

  return schema;
}
